import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Provider } from 'react-redux';

import configureStore from './store/configure';
import Page from './page';

export default function ShadowsIndex({
  creating,
  emptyState,
  onCreatingChange,
  onListShownChange,
  setDirty,
  selectedShadow,
  selectShadow,
  showHeader,
  ...initialState
}) {
  const [store] = useState(() => configureStore(initialState));

  return (
    <Provider store={store}>
      <Page
        creating={creating}
        emptyState={emptyState}
        selectedGlobalShadow={selectedShadow}
        selectGlobalShadow={selectShadow}
        setDirty={setDirty}
        showHeader={showHeader}
        onCreatingChange={onCreatingChange}
        onListShownChange={onListShownChange}
      />
    </Provider>
  );
}

ShadowsIndex.propTypes = {
  creating: PropTypes.bool,
  emptyState: PropTypes.node,
  selectedShadow: PropTypes.object,
  selectShadow: PropTypes.func,
  setDirty: PropTypes.func,
  showHeader: PropTypes.bool,
  onCreatingChange: PropTypes.func,
  onListShownChange: PropTypes.func,
};
